import React from 'react';
import PropTypes from 'prop-types';
import { Card as BootstrapCard } from "reactstrap";
import './Card.scss';

export const Card = ({ variant, className, children, hoverEffect, ...rest }) => {
  let extendClassName = undefined;
  if (variant === "primary")
  {
    extendClassName = "bg-secondary mb-0 border border-1 border-light"
  }
  if (variant === "secondary")
  {
    extendClassName = "bg-white mb-0 border border-1 border-light"
  }
  
  // Add hover effect class if hoverEffect prop is true
  const hoverEffectClass = hoverEffect ? 'card-hover-effect' : '';
  
  return (
    <BootstrapCard
      className={`rounded-4 ${extendClassName ? extendClassName : ""} ${hoverEffectClass} ${className ? className : ""}`}
      style={{ overflow: 'hidden' }}
      {...rest}
    >
      {children}
    </BootstrapCard>
  );
};

Card.propTypes = {
  variant: PropTypes.oneOf(['default','primary']),
  hoverEffect: PropTypes.bool,
};

Card.defaultProps = {
  hoverEffect: false,
};
